<template>
    <Layout>
      <div class="row">
        <div class="col-12">
                <div class="row">
                  <div class="col-md-3">
                    <div class="card">
                    <div class="card-header bg-primary rounded-1 text-white">{{ service }}</div>
                    <div class="card-body p-2">
                      <div class=" mb-2 d-flex justify-content-between">
                        <img class="img-rounded" src="@/assets/images/sick.png" height="70px" />
                        <span><a @click="$router.go(-1)" type="button" class="btn-sm btn btn-primary"> <i class="mdi mdi-undo"></i> back</a></span>
                      </div>
                      <span v-if="patientspinner==false">
                      <table v-for="item in patients" :key="item.id" class="table">
                      <tr><td>Full Name </td><td> <b class="text-primary h7">{{ item.name }} </b></td></tr>
                      <tr><td>Gender </td><td> <span class="text-primary h7">{{ item.gender }} </span></td></tr>
                      <tr><td> Telephone </td><td> <span class="text-primary h7">0{{ item.telephone }} </span></td></tr>
                      <tr><td> Date of Birth </td><td> <span class="text-primary h7">{{ item.date_of_birth }} </span></td></tr>
                      <tr><td> Email Address </td><td> <span class="text-primary h7">{{ item.email }} </span></td></tr>
                      <tr><td> Address </td><td> <span class="text-primary h7">{{ item.address }} </span></td></tr>
                      <tr><td> Nationality </td><td> <span class="text-primary h7">{{ item.nationality }} </span></td></tr>
                      </table>
                      <h5 class="my-3"><i class="mdi mdi-calendar"></i> &nbsp;&nbsp; {{ visit_date }}</h5>

                      </span>
                      <span v-else>
                        <i class="fas fa-spinner fa-3x p-5 text-primary fa-spin"></i> 
                      </span>
                    </div>
                    </div>
                  </div>
                  <div class="col-md-9">
                    <b-tabs pills nav-class="p-0" content-class="text-dark">
                      <b-tab active class="border-0">
                        <template v-slot:title>Operation Notes</template>
                        <div class="card">
                          <div class="card-body">
                            <span v-if="consentform==''">
                            <form @submit.prevent="addConsentForm">
                            <div class="row gy-2 gx-2 align-items-center">
                            <div class="col-auto">
                                <label>Upload Consent form</label>
                                <input type="file" class="form-control" v-on:change="onFileChange">
                            </div>
                            <div class="col-auto">
                                <b-button variant="primary" type="submit" class="w-md mt-4">Upload</b-button>
                            </div>
                            </div>
                            </form>
                            </span>
                            <span v-else>
                            <div v-for="item in consentform" :key="item.id">
                                <i class="mdi mdi-file-outline text-primary h1"></i> &nbsp; &nbsp;
                                <span class="h5 text-primary">Consent form</span>&nbsp; &nbsp;
                                <a :href="getFiles(item.form_label)" download class="btn btn-sm btn-primary"> <i class="mdi mdi-download"></i> </a>&nbsp; &nbsp;
                                <a target="_blank" :href="getFiles(item.form_label)" class="btn btn-sm btn-danger"> <i class="mdi mdi-eye"></i> </a>
                            </div>
                            </span>
                            <br>
                              <form @submit.prevent="addTreatment">
                                <label class="mt-2">Operation Notes</label>
                                <tinymce id="d1" v-model="diagnosis"></tinymce>
                                <label class="mt-2">Management Plan</label>
                                <tinymce id="d2" v-model="recommedation"></tinymce>
                                <div class="form-group d-flex justify-content-end mt-3">
                                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
                                </div>
                              </form>
                          </div>
                        </div>
                      </b-tab>
                      <b-tab class="border-0">
                          <template v-slot:title>Presciptions</template>
                          <div class="card">
                            <div class="card-body">
                              <b-button v-b-modal.new-prescription size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Prescription</b-button>
                              <table class="table table-sm mt-2" style="color: black;" density="compact">
                              <thead><tr><th>Medicine</th><th>Dosage</th><th>Note</th></tr></thead>
                              <tbody>
                                <tr v-for="item in prescriptions" :key="item.id">
                                    <td>{{ item.medicine.name }} </td>
                                    <td>{{ item.dosage }}</td>
                                    <td>{{ item.note }}</td>
                                </tr>
                              </tbody>
                              </table>
                            </div>
                          </div>
                      </b-tab>
                      <b-tab class="border-0">
                        <template v-slot:title>Services</template>
                        <div class="card">
                          <div class="card-body">
                              <b-button v-b-modal.new-service size="sm" variant="primary"><i class="mdi mdi-plus"></i> Add a Service</b-button>
                              <table class="table table-sm mt-2" style="color: black;" density="compact">
                              <thead><tr><th>Category</th><th>Service Name</th><th>Service Price</th><th>Status</th></tr></thead>
                              <tbody>
                                <tr v-for="item in services" :key="item.id">
                                    <td>{{ item.service_category.name }} </td>
                                    <td>{{ item.service_name.name }}</td>
                                    <td>{{ item.service_price }}</td>
                                    <td>
                                      <span v-if="item.status==1">
                                        <span class="btn btn-sm btn-dark">Pending</span>
                                      </span>
                                      <span v-else>
                                        <b-button @click="edit(item.service_name.id,item.service_name.name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-clipboard-list"></i> results </b-button>
                                      </span>
                                    </td>
                                </tr>
                              </tbody>
                              </table>
                          </div>
                        </div>
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
        </div>
      </div>
      <b-modal id="new-service" size="md" title="New Service" title-class="font-14" hide-footer>
        <form @submit.prevent="AddPatientService">
          <div class="form-group mb-2">
            <label>Service Category</label> <small class="text-danger">*</small>
            <multiselect v-model="service_category" @input="FilterCategory" :options="servicecategories" label="name"></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Service Name</label> <small class="text-danger">*</small>
            <multiselect v-model="service_name" label="name" @input="FilterServicePrice" :options="newservices"></multiselect>
          </div>
          <div class="form-group mb-2">
            <label>Service Cost</label> <small class="text-danger">*</small>
            <input v-model="service_price" readonly required type="number" class="form-control" />
          </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-service')" >Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
      </b-modal>
  
      <b-modal id="new-prescription" centered title="New Prescription" title-class="font-18" hide-footer>
          <form @submit.prevent="addPrescription">
            <div class="form-group mb-2">
              <label>Medicine</label>
                <multiselect v-model="medicine" @input="FilterProductUnits" :options="products" label="name"></multiselect>
              </div>
              <div class="row">
              <div class="col-md-6">
              <label>Unit</label>
                <multiselect v-model="unit" @input="FilterPrice" :options="units" label="unit"></multiselect>
              </div>
              <div class="col-md-6">
              <label>Price</label>
                <input v-model="price" type="number" readonly class="form-control" />
              </div>
              </div>
              <div class="row">
                <div class="col-4">
                  <label>Dose</label>
                  <input v-model="dose" type="number"  @input="CheckMedicine" min="1" required class="form-control" />
                </div>
                <div class="col-4">
                  <label>Frequency</label>
                  <input v-model="frequency" type="number" @input="CheckMedicine" min="1" required class="form-control" />
                </div>
                <div class="col-4">
                  <label>Duration</label>
                  <input v-model="duration" type="number" @input="CheckMedicine" min="1" required class="form-control" />
                </div>
              </div>
              <div class="form-group mb-2">
              <label>Total Amount</label>
                <input v-model="totalprice" type="number" readonly class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Prescription Note</label>
              <textarea v-model="note" rows="2" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-prescription')" >Close</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="view-results" centered :title="resultname" title-class="font-14" hide-footer>
          
        <span v-for="item in treatmentresults" :key="item.id">
          <div class="row">
            <div class="col-md-6">
              <span>Presented Complaints <span class="text-info h5" v-html="item.symptoms"></span></span>
              <span>History of Presented Complaints <span class="text-info h5" v-html="item.history"></span></span>
              <span>General Examination to Review of Systems <span class="text-info h5" v-html="item.examination"></span></span>
            </div>
            <div class="col-md-6" style="border-left: 1px solid grey;">
              <span>Provisional Diagnosis <span class="text-info h5" v-html="item.diagnosis"></span></span>
              <span>Recommendation <span class="text-info h5" v-html="item.recommedation"></span></span>
            </div>
          </div>
        </span>
  
      </b-modal>
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  import Layout from "../../layouts/main";
  import appConfig from "@/app.config";
  import Multiselect from "vue-multiselect";
  import { productMethods, productComputed , serviceCategoryMethods,serviceCategoryComputed} from "@/state/helpers";
  
  export default {
    page: {
      title: "Patient Treatment",
      meta: [{name: "description",content: appConfig.description,},],
    },
    components: {
      Layout,Multiselect,
    },
    data() {
      return {
        title: "Patient Treatment",
        items: [{text: "Dashboard",to: "/",},{text: "Patients",active: true,},],
        patients:[],
        patientsymptoms:[],
        patientdiseases:[],
        prescriptions:[],
        diagnosis:[],
        symptoms:[],
        services:[],
        newservices:[],
        patientspinner:true,
        patientid:'',
        visitid:'',
        service:'',
        service_id:'',
        recommedation:'',
        examination:'',
        history:'',
        medicine:'',
        price:'',
        quantity:'',
        dose:'1',
        frequency:'1',
        duration:'1',
        note:'',
        units:[],
        unit:'',
        totalprice:'',
        service_category:[],
        service_name:[],
        service_price:'',
        patient_type:'1',
        resultid:'',
        resultname:'',
        treatmentresults:[],
        files:'',
        consentform:[],
      visit_date:'',
      };
    },
    computed: {
        ...productComputed,
        ...serviceCategoryComputed,
    },
    created() {
      this.fetchServiceCategory();
      this.fetchProducts();
      this.fetchInfo();
    },
    methods: {
      ...productMethods,
      ...serviceCategoryMethods,
      onFileChange(e){
        this.files = e.target.files[0];
      },
      getFiles(name){
        let url = axios.defaults.baseURL;
        let imagelink = (url).slice(0,-3)+"consentforms/"+name;
        return imagelink;
      },
      async edit(id,name){
        this.resultid=id;
        this.resultname=name;
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.resultid}`;
        await axios.get(url).then((response) => {
          this.treatmentresults = response.data.treatments;
        });
        this.$bvModal.show('view-results')
      },
      async fetchInfo(){
        this.id=this.$route.query.id;
        let url = `/visitinfo/${this.id}`;
        await axios.get(url).then((response) => {
          this.patientid = response.data.visits[0].patient.patient_id;
          this.visitid = response.data.visits[0].visit_id;
          this.service = response.data.visits[0].service_name.name;
          this.service_id = response.data.visits[0].service_name.id;
          this.visit_date = response.data.visits[0].addedon;
          this.showpatient();
          this.showtprescriptions();
          this.showtreatments();
          this.showservices();
          this.showConsentform();
        });
      },
      async FilterCategory(){
        let url = `/servicebycategory/${this.service_category.id}`;
          await axios.get(url).then((response) => {
            this.newservices = response.data.services;
          });
      },
      async FilterServicePrice(){
          let url = `/serviceprice/${this.service_name.id}`;
          await axios.get(url).then((response) => {
            this.service_price = response.data.price;
            });
        },
      CheckMedicine(){
        this.totalprice = this.price*this.dose*this.frequency*this.duration;
      },
      async FilterProductUnits(){
          let url = `/unitsbyproduct/${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.units = response.data.units;
            });
        },
        async FilterPrice(){
          let url = `/productbyunitprice/${this.unit.unit_id},${this.medicine.id}`;
          await axios.get(url).then((response) => {
            this.price = response.data.price;
            this.CheckMedicine();
            });
        },
      async showpatient(){
        let url = `/patientprofile/${this.patientid}`;
        await axios.get(url).then((response) => {
          this.patients = response.data.patients;
          this.patientspinner=false;
        });
      },
      async showservices(){
        let url = `/profileservices/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.services = response.data.visits;
        });
      },
      async showConsentform(){
        let url = `/consentform/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.consentform = response.data.form;
        });
      },
      async showtprescriptions(){
        let url = `/profileprescription/${this.patientid},${this.visitid}`;
        await axios.get(url).then((response) => {
          this.prescriptions = response.data.prescriptions;
        });
      },
      async showtreatments(){
        let url = `/profiletreatment/${this.patientid},${this.visitid},${this.service_id}`;
        await axios.get(url).then((response) => {
        if (response.data.treatments.length===0) {
          this.symptoms = '';
          this.history = '';
          this.examination = '';
          this.diagnosis = '';
          this.recommedation = '';
        }else{
          this.symptoms = response.data.treatments[0].symptoms;
          this.history = response.data.treatments[0].history;
          this.examination = response.data.treatments[0].examination;
          this.diagnosis = response.data.treatments[0].diagnosis;
          this.recommedation = response.data.treatments[0].recommedation;
          this.patient_type = response.data.treatments[0].patient_type;
        }
        });
      },
      async addConsentForm(){
        let formData = new FormData();
          formData.append("patient_id", this.patientid);
          formData.append("visit_id", this.visitid);
          formData.append("file", this.files);
          let url = "/addconsentform";
          await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
              this.showConsentform();
              this.files="";
              this.$toast.success(response.message);
          }
          });
      },
      async AddPatientService() { 
          let formData = new FormData();
          formData.append("patient_id", this.patientid);
          formData.append("visit_id", this.visitid);
          formData.append("service_category", this.service_category.id);
          formData.append("service_name", this.service_name.id);
          formData.append("service_price", this.service_price);
          let url = "/addpatientvisit";
          await axios.post(url, formData).then((response) => {
          if (response.status == 200) {
              this.showservices();
              this.$bvModal.hide('new-service');
              this.service_category="";
              this.service_name="";
              this.service_price="";
              this.$toast.success("New Patient Service Added");
          }
          });
        },
      async addTreatment() { 
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("service_id", this.service_id);
        formData.append("symptoms", this.symptoms);
        formData.append("history", this.history);
        formData.append("examination", this.examination);
        formData.append("recommedation", this.recommedation);
        formData.append("diagnosis", this.diagnosis);
        formData.append("patient_type", this.patient_type);
        let url = "/addtreatment";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.showtreatments();
          this.showservices();
            this.symptoms="";
            this.history="";
            this.examination="";
            this.recommedation="";
            this.diagnosis="";
            this.patient_type="1";
            this.$toast.success("Patient Treatment Added");
        }
        });
      },
      async addPrescription() {
        let formData = new FormData();
        formData.append("patient_id", this.patientid);
        formData.append("visit_id", this.visitid);
        formData.append("service_id", this.service_id);
        formData.append("medicine", this.medicine.id);
        formData.append("unit", this.unit.unit_id);
        formData.append("dosage", this.dose+" * "+this.frequency+" * "+this.duration );
        formData.append("quantity", this.dose*this.frequency*this.duration );
        formData.append("totalprice", this.totalprice);
        formData.append("note", this.note);
        let url = "/addprescription";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.$bvModal.hide('new-prescription');
            this.showtprescriptions();
            this.medicine="";
            this.dose="";
            this.frequency="";
            this.duration="";
            this.note="";
            this.$toast.success("Patient Prescription Added");
        }
        });
      },
    },
  };
  </script>